/**
 * スケジュールブロックのフロント用スクリプト。
 * 必要に応じてここに処理を追加できます。
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
